<template>
  <div class="interact-container">
    <div class="interact-container-banner">
      <img
        src="https://image.bookgo.com.cn/bgOfficial/banners/interact-banner.png"
        alt=""
      />
      <div class="interact-container-banner-box">
        <div class="interact-container-banner-box-content">
          <h2>互动图书馆解决方案</h2>
          <p>互动图书馆解决方案实现了让图书馆变得智慧化、趣味化</p>
          <p>让阅读不再传统，进入新型阅读时代</p>
          <p>
            能够更大的激发读者对知识的探索兴趣和推动图书馆向电子化、虚拟化、趣味化、多样化时代进步
          </p>
        </div>
      </div>
    </div>
    <!-- 智慧阅读空间 -->
    <div class="interact-container-readspace">
      <h2 class="interact-container-readspace-title title-common">
        智慧阅读空间
      </h2>
      <div class="interact-container-readspace-content">
        <ul class="interact-container-readspace-content-list">
          <li v-for="(item, i) in productList" :key="i">
            <img :src="item.pic" alt="" />
            <p>{{ item.name }}</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 互动体验空间 -->
    <div class="interact-container-experience">
      <h2 class="interact-container-experience-title title-common">
        互动体验空间
      </h2>
      <div class="interact-container-experience-tab">
        <tab :tabList="tabList" />
      </div>
    </div>
    <toTop />
  </div>
</template>

<script>
import tab from "@/assets/components/tab";
import toTop from "@/assets/components/toTop";
export default {
  data() {
    return {
      productList: [
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/interact/readspace-item1.png",
          name: "数字阅读机",
          introduction:
            "智能RFID标签在图书馆行业的应用，大大改变了整个书籍流通的效率，迈向互联时代。RFID分高频和超高频，在书籍中、读者证中、层架标签中都采用了RFID芯片和通信机制。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/interact/readspace-item2.png",
          name: "云桌面电子阅览室",
          introduction:
            "一体化馆员工作站是将RFID读写板、图书标签转换系统和显示屏结合的智能一体机。可对图书标签和读者证卡进行编写、识别和流通状态处理，用于图书的标签转换及图书人工借还状态处理。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/interact/readspace-item3.png",
          name: "墨水屏电子书阅览系统",
          introduction:
            "自助借还一体机采用立体式设计，提供便捷化的操作模式和友好的图形界面，集借还书、检索、缴费、电子书借阅等多功能于一体，同时满足图书流通的多种业务需求，为读者提供智能化的自助服务。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/interact/readspace-item4.png",
          name: "创客空间研讨系统",
          introduction:
            "自助借还一体机采用立体式设计，提供便捷化的操作模式和友好的图形界面，集借还书、检索、缴费、电子书借阅等多功能于一体，同时满足图书流通的多种业务需求，为读者提供智能化的自助服务。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/interact/readspace-item5.png",
          name: "朗读亭",
          introduction:
            "智能书架产品以RFID技术为核心，结合工控机、网络控制、灯光控制、冲压结构等形成的可以对图书进行自动盘点和查询的高性能智能图书存放产品。该产品可以大大降低图书盘点时间，有效节约了借阅者的查书时间，真正做到了对图书管理的智能化和高效化。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/interact/readspace-item6.png",
          name: "多屏互动展示系统",
          introduction:
            "24小时自助还书机是一款人性化、智能化的还书设备，读者还书将不再受图书馆开、闭管时间的限制，可在任意时间还书。设备可配合自动分拣设备和码放设备使读者还回的图书自动分进不同的还书车，大大降低图书馆工作人员的工作量，提升效率。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/interact/readspace-item7.png",
          name: "智能导览导视一体机",
          introduction:
            "智能盘点设备能够方便图书工作人员进行图书上架、图书盘点、统计查询等工作。移动盘点车可搭配多个手持盘点终端，满足多人同时协同盘点。盘点系统支持与手机排架系统无缝对接，准确定位图书位置，便于读者快速查找图书。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/interact/readspace-item8.png",
          name: "体感互动长廊",
          introduction:
            "智能盘点设备能够方便图书工作人员进行图书上架、图书盘点、统计查询等工作。移动盘点车可搭配多个手持盘点终端，满足多人同时协同盘点。盘点系统支持与手机排架系统无缝对接，准确定位图书位置，便于读者快速查找图书。",
        },
        {
          pic:
            "https://image.bookgo.com.cn/bgOfficial/rfid/rfid-index-product12.png",
          name: "",
          introduction: "",
        },
      ],
      tabList: [
        {
          rank: "01",
          title: "体感答题互动系统",
          desc:
            "体感互动答题系统采用了最新的体感互动技术，让用户通过简单自然的肢体互动来体验答题的乐趣，突破了传统的鼠标、键盘和触摸屏等接触式问答系统，用户无需接触任何设备，就可以在富有科幻性、互动性和趣味性的环境中学习到知识。",
          pic:
            "https://image.bookgo.com.cn/bgOfficial/interact/interact-tab-item1.png",
          subpic: "",
        },
        {
          rank: "02",
          title: "AI导览服务系统",
          desc:
            "AI导览服务机器人能够智能引导读者前往不同区域，语音交互我要去哪里，机器人会智能显示室内导览地图路线；语音交互我要找那本书，机器人会智能规划路线和告知场馆区域；点击前往，机器人可带领读者前往对应区域，让读者享受AI交流式引导服务。同时后台可自定义交互，展示场馆个性化内容。",
          pic:
            "https://image.bookgo.com.cn/bgOfficial/contact/contactus-pic.png",
          subpic: "",
        },
        {
          rank: "03",
          title: "数字书法学习系统",
          desc:
            "数字书法体验系统，是融合数字科技以新颖方式体验和学习传统书法，还原传统书法和文房四宝的书写氛围，用真实的毛笔，在电子屏幕上自由创作，不用墨水即可书写毛笔汉字，可以激发更多学生热爱和传播书法文化。",
          pic:
            "https://image.bookgo.com.cn/bgOfficial/interact/interact-tab-item3.png",
          subpic: "",
        },
        {
          rank: "04",
          title: "电子益智棋桌",
          desc:
            "智能电子益智棋桌是通过现代科技与传统棋文化的有机结合，打造一个数字化可触摸交互的大屏设备为载体的棋文化载体，让棋文化的学习与体验相辅相成，使得在学生群体中更好的普及和传播棋文化。本产品还原了对弈的真实场景，棋桌古色古香富有文化底蕴，同时兼具科技体验感。",
          pic: "https://image.bookgo.com.cn/bgOfficial/common/table.png",
          subpic: "",
        },
        {
          rank: "05",
          title: "VR沉浸式3D观影仓",
          desc:
            "3D VR观影仓，是新一代沉浸式体验虚拟观影空间，用户可在360°虚拟环境钟观看电影精彩场景，本观影仓配备4K超高清头显，涵盖全球精选影视内容，采用人体工程学座椅设计，从而实现全身心虚拟互动式舒适观影体验。",
          pic:
            "https://image.bookgo.com.cn/bgOfficial/interact/interact-tab-item5.png",
          subpic: "",
        },
        {
          rank: "06",
          title: "VR沉浸阅读系统",
          desc:
            "VR沉浸式虚拟阅读空间是利用最新的VR和MR技术，为读者打造出720°全方位精美沉浸式阅读环境，在此空间，读者可瞬间进入全新美好惊艳的世界，拿起实体书本，可在虚拟环境中体验静谧心旷神怡的阅读感受，可成为读者印象深刻无与伦比的学习圣地。",
          pic:
            "https://image.bookgo.com.cn/bgOfficial/interact/interact-tab-item6.png",
          subpic: "",
        },
      ],
    };
  },
  components: {
    tab,
    toTop,
  },
};
</script>

<style lang="scss">
@import "../../../assets/scss/libInteract.scss";
</style>
